<template>
    <b-container fluid class="headerPushDown">
        <b-container class=" ml-auto mr-auto" >
           <form @submit.stop.prevent="handleRegisterSubmit" v-if="!isRestistrationDone">
            <h3 v-html="getLanguageItem['RegisterStrings']['Header']"></h3>

            <b-form-group class="mt-4 pl-3 pr-3">
            <b-row>
                <b-col sm="2" md="3" v-if="!isEnabled"> <!-- PLACEHOLDER FOR CENTERING NEXT COL --></b-col>
                <b-col sm="12" md="6" class="mb-2">
                    <h4 class="text-uppercase">Rechnungsadresse:</h4>
                    <shop-customer-address-inputs v-bind:address="billingAddress" v-bind:enabled="'true'" v-bind:addressValidation="addressValidation"/>
                </b-col>
                <b-col sm="12" md="6" class="mb-2" v-if="isEnabled">
                    <h4 class="text-uppercase">Lieferadresse:</h4>
                    <shop-customer-address-inputs v-bind:address="shippingAddress" v-bind:enabled="enableShippingAddress" v-bind:addressValidation="addressValidation"/>
                </b-col>
            </b-row>
           <b-row>
               <b-col sm="2" md="3" v-if="!isEnabled"></b-col>
               <b-col sm="12" md="6" class="mb-3">
                   <b-form-checkbox class="float-left"
                        id="useShippingAddress"
                        v-model="enableShippingAddress"
                        value="true"
                        unchecked-value="false">
                        andere Zustelladresse verwenden
                    </b-form-checkbox>
               </b-col>
           </b-row>
            <b-row>
                <b-col sm="12" md="6" class="mt-3 mt-md-0">
                    <label class="text-uppercase mb-0">E-Mail Adresse*</label>
                    <b-input v-model="email" type="email" size="md" placeholder="E Mail" id="email_"
                        :class="{'is-invalid' : !emailIsValid}"
                        :state="emailState" class="InputBorder mt-0 mb-2"/>

                    <label class="text-uppercase mb-0">E-Mail Adresse wiederholen*</label>
                    <b-input v-model="email2" type="email" size="md" placeholder="E Mail" id="email"
                        :class="{'is-invalid' : !emailIsValid}"
                        aria-describedby="input-live-feedback"
                        :state="emailState" class="InputBorder mt-0 mb-2"/>
                    <b-form-invalid-feedback id="input-live-feedback" class="mb-2">
                        Bitte E-Mail Adressen überprüfen
                    </b-form-invalid-feedback>

                    <label class="mb-0 text-uppercase">Geburtsdatum</label>
                    <div class="mt-0 mb-2 " :class="$options.name">
                        <form-date v-model="birthdate" />
                    </div>

                    <label class="text-uppercase mb-0">Telefon</label>
                    <b-input type="text" size="md" v-model="phone" placeholder="Telefon" id="phone" class=" InputBordermt-0 mb-2"/>
                    <b-form-checkbox class="mt-3 mb-2"
                        id="newsletter"
                        v-model="newsletter"
                        value="true"
                        unchecked-value="false">
                        Newsletter bestellen
                    </b-form-checkbox>
                    <p>*Pflichtfelder</p>
                </b-col>

                <b-col sm="12" md="6">
                    <label class="text-uppercase mb-0">Passwort</label>
                    <b-input type="password" :state="passwordState" size="md" aria-describedby="input-live-feedback" placeholder="Passwort" class="InputBorder mt-0 mb-2" v-model="password"/>

                    <label class="text-uppercase mb-0">Passwort wiederholen</label>
                    <b-input type="password" :state="passwordState" size="md" aria-describedby="input-live-feedback" placeholder="Passwort wiederholen" class="InputBorder mt-0 mb-2" v-model="password2"/>
                    <b-form-invalid-feedback id="input-live-feedback2">
                         Bitte Passworte überprüfen
                    </b-form-invalid-feedback>
<p>Ihr Passwort kann 8-30 Zeichen enthalten und muss zumindest einen Großbuchstaben, einen Kleinbuchstaben und eine Nummer beinhalten</p>
                </b-col>

            </b-row>
            <b-row>
                <b-col sm="2" md="3"></b-col>
                <b-col sm="8" md="8">
                    <vue-recaptcha v-if="siteKey" class="" :sitekey="siteKey" ref="recaptcha" @expired="onCaptchaExpired" @verify="onCaptchaVerified"></vue-recaptcha>
                </b-col>
                <b-col sm="2" md="3" ></b-col>
            </b-row>
            <b-row>
                <b-col>
                     <div v-if="validationError" class="d-inline-block text-danger mb-2">
                        <div v-for="(vError, index) in validationError" :key="index">
                            {{vError}}
                        </div>
                    </div>
                    <b-button v-if="!reCaptchaOK" @click="handleRegisterSubmit" disabled class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
                        REGISTRIEREN
                    </b-button>
                    <b-button v-if="reCaptchaOK" @click.prevent="handleRegisterSubmit" class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
                        REGISTRIEREN
                    </b-button>


                </b-col>
            </b-row>
            </b-form-group>
          </form>
          <b-row v-if="isRestistrationDone">
              <b-col cols="0" md="3"></b-col>
              <b-col cols="12" md="6">
                <h4>Vielen Dank!</h4>
                <p>
                    Hervorragend - der Registrierungsvorgang wurde erfolgreich eingeleitet,
                    eine E-Mail Bestätigung ist auf dem Weg.
                    <br>Bitte folge der Anleitung im E-mail um die Regirstrierung abzuschließen.

                    <br><br>Bis bald ganz oben!
                    <br> Das Kahlenberg-Team
                </p>
                <b-button  to="/app/login" class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
                        Login
                </b-button>
              </b-col>
          </b-row>
        </b-container>
  </b-container>
</template>


<script>
import ShopCustomerAddressInputs from "@/components/ShopCustomerAddressInputs";
import VueRecaptcha from 'vue-recaptcha';
import FormDate from '@/components/FormDate.vue';
//import { timeout } from 'q';

export default {
    name:'ShopRegisterView',
    components: {
        VueRecaptcha,
        ShopCustomerAddressInputs, FormDate
    },
    data() {
        return {
            login: '',
            password: '', password2: '', passwordIsValid: true,
            siteKey: undefined,
            reCaptchaOK: false,
            reCaptchaToken: undefined,
            billingAddress: {
                firstname:'',
                firstnameIsValid: true,
                lastname: '',
                lastnameIsValid: true,
                street: '',
                streetIsValid: true,
                zip: '',
                zipIsValid: true,
                city: '',
                cityIsValid: true,
                country: '',
                countryIsValid: true,
            },
            shippingAddress: {
                firstname:'',
                firstnameIsValid: true,
                lastname: '',
                lastnameIsValid: true,
                street: '',
                streetIsValid: true,
                zip: '',
                zipIsValid: true,
                city: '',
                cityIsValid: true,
                country: '',
                countryIsValid: true,
            },
            enableShippingAddress: 'false',
            email: '',email2: '',
            emailIsValid: true,
            birthdate: '',
            phone: '',
            newsletter: false,
            customerData: undefined,
            validationError: undefined,
            addressValidation: {
                firstname: { MinLetters: 2},
                lastname: {MinLetters: 2},
                street: {MinLetters: 3},
                zip: {MinLetters: 3},
                city: {MinLetters: 3},
                country: {MinLetters: 3},
            },
            isRestistrationDone: undefined,
            RestrationDoneMessage: '',
        }
    },
    computed: {
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        isEnabled(){
            //console.log('enableShippingAddress: ', this.enableShippingAddress);

            // bloody strings ?!
            if(this.enableShippingAddress == 'true'){
                //console.log('enableShippingAddress enabled');
                return true;
            }else if(this.enableShippingAddress == 'false'){
                //console.log('enableShippingAddress disabled');
                return false;
            }else if(this.enableShippingAddress == true){
                //console.log('enableShippingAddress TRUE ', this.enabled);
                return true;
            }else{
                return false;
            }
        },
        emailState(){
            // this looks like a valid email address
            if(this.email == '' || this.email2 == '' ){
                return;
            }
            if(this.email.match(this.$store.getters.getMailFormat) &&  this.email2.match(this.$store.getters.getMailFormat) && this.email== this.email2){
                this.setEmailIsValid();
                return true;
            }else{
                this.setEmailIsInvalid();
                return false;
            }
        },
        passwordState(){
            if(this.password.length > 1 && this.password2.length > 1){
                if(this.password.match(this.$store.getters.getPasswordFormat) && this.password2.match(this.$store.getters.getPasswordFormat) && this.password == this.password2){
                    return true;
                }else{
                    return false;
                }
            }else{
                return undefined;
            }
        },

    },
    methods:{
        validateAddress(address, validation, prefix = ''){
            if (address.firstname == undefined ||
                address.firstname.trim() == '' ||
                address.firstname.trim().length < validation.firstname.MinLetters) {

                address.firstnameIsValid = false;

                this.validationError.push(prefix + 'Vornamen überprüfen');
            }else{
                address.firstnameIsValid = true;
            }

            if (address.lastname == undefined ||
                address.lastname.trim() == '' ||
                address.lastname.trim().length < validation.lastname.MinLetters) {
                address.lastnameIsValid = false;
                this.validationError.push(prefix + 'Nachnamen überprüfen');
            }else{
                address.lastnameIsValid = true;
            }

            if (address.street == undefined ||
                address.street.trim() == '' ||
                address.street.trim().length < validation.street.MinLetters) {
                address.streetIsValid = false;
                this.validationError.push(prefix + 'Strasse überprüfen');
            }else{
                address.streetIsValid = true;
            }

            if (address.zip == undefined ||
                address.zip.trim() == '' ||
                address.zip.trim().length < validation.zip.MinLetters) {
                address.zipIsValid=false;
                this.validationError.push(prefix + 'Postleitzahl überprüfen');
            }else{
                address.zipIsValid=true;
            }

            if (address.city == undefined ||
                address.city.trim() == '' ||
                address.city.trim().length < validation.city.MinLetters) {
                address.cityIsValid = false;
                this.validationError.push(prefix + 'Stadt überprüfen');
            }else{
                address.cityIsValid = true;
            }

            if (address.country == undefined ||
                address.country.trim() == '' ||
                address.country.trim().length < validation.country.MinLetters) {
                address.countryIsValid = false;

                this.validationError.push(prefix + 'Land überprüfen');
            }else{
                address.countryIsValid = true;
            }

            if(this.validationError != undefined &&  this.validationError.length >0){
                //console.log('Address Validation had errors:', this.validationError);

                return false;
            }

            // ALL Good
            //console.log('Address validation ok:');

            return true;

        },
        handleRegisterSubmit(){

           this.validationError = [];

            // Validate Address
            if (!this.validateAddress(this.billingAddress, this.addressValidation, 'Rechnungsadresse: ')) {
                  //  return;
            }

            // Validate shipping address ?
            if (this.enableShippingAddress == true || this.enableShippingAddress == 'true') {
                //console.log('Validating Shipping address');

                if (!this.validateAddress(this.shippingAddress, this.addressValidation, 'Lieferadresse: ') ) {
                    //return;
                }
            }

            if (!this.emailState) {
                this.validationError.push('E-Mail Adressen überprüfen');
                this.emailIsValid = false;
            }else{
                this.emailIsValid = true;
            }

            if(!this.passwordState){
                //console.log('PW State false');
                this.validationError.push('Passwörter überprüfen');
            }else{
                //console.log('PW State OK');
            }

            if(this.validationError != undefined && this.validationError.length > 0){

                //console.log('Validation failed: ', this.validationError);

            }else{
// No Errors
                let params = {};

                if(this.enableShipping == 'true' || this.enableShipping == true){
                    params = {
                        emailAddress: this.email,
                        password: this.password,
                        reCaptcha: this.reCaptchaToken,
                        newsletter: this.newsletter,
                        customerData: {
                            billingAddress: this.billingAddress,
                            shippingAddress: this.shippingAddress,
                            phone: this.phone,
                           // birthDate: new Date(this.birthdate).toISOString()
                        }
                    };
                }else{
                    params = {
                        emailAddress: this.email,
                        password: this.password,
                        reCaptcha: this.reCaptchaToken,
                        newsletter: this.newsletter,
                        customerData: {
                            billingAddress: this.billingAddress, // no shippingaddress!
                            phone: this.phone,
                           // birthDate: new Date(this.birthdate).toISOString()
                        }
                    };
                }
                // only use Date if guest
                if(this.birthdate){
                        params.customerData.birthDate = new Date(this.birthdate).toISOString().slice(0,10);
                        //console.log('db:',params.customerData.birthDate );

                }else{
                    //console.log('No Birthdate');
                }

                // send to Server
                this.postRegisterToServer(params);
             }
        },
        setEmailIsValid(){

            this.emailIsValid = true;
           // console.log('TRUE validated: ', this.emailIsValid);
        },
        setEmailIsInvalid(){

            this.emailIsValid = false;
           // console.log('FALSE validated: ',this.emailIsValid);
        },
        onCaptchaVerified(recaptchaToken){
            //console.log('recaptchaToken: ', recaptchaToken);
            this.reCaptchaOK = true;
            this.reCaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
            this.reCaptchaOK = false;
            this.reCaptchaToken = undefined;
        },
        async loadRecaptchaKeyFromServer() {
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = null;

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/recaptchaKey", config)
                .then(response => {
                    // console.log("GET recaptchaKey: " + response.status);
                    // console.log(response.data);
                    this.siteKey = response.data;

                    //console.log('stored recaptchaKey: ', this.$store.getters.getBasket);
                })
                .catch(err => {
                console.log("GET recaptchaKey ERROR: ", err);

                });
        },
        async postRegisterToServer(params) {

        let config = this.$store.getters.getRestHeaderConfig;
        config.params = undefined; // make sure they are empty

        //console.log('POST REGISTER<:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/registerCustomer", params , config)
            .then(response => {
                //console.log("POST REGISTER response: "  + response.status, response);
                // message that a mail was sent...
// SHOW link to login
                this.isRestistrationDone = true;
                this.RestrationDoneMessage = '';
                response.data = '';

                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });

            })
            .catch(err => {
                console.log("POST REGISTER ERROR: ", err);

            });
        },
        async PostLogintoServer(login, pw) {

        let config = this.$store.getters.getRestHeaderConfig;
        config.params = undefined; // make sure they are empty
        // prepare Parameters
        let params = {
            username: login, // this.login.trim(),
            password: pw, // this.password.trim(),
        };

        //console.log('Login Seite Params:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/login" , params , config)
            .then(response => {
               // console.log('Login OK: ', response);
                this.$store.dispatch('setCustomerLoginStatus', {customerName:this.login, loggedIn: true });

                // go Back to last route...?
                if(this.$store.getters.getPreviousRoute != undefined){
                    //console.log('go Back: ', this.$store.getters.getPreviousRoute );
                    this.$router.push(this.$store.getters.getPreviousRoute.from );
                }else{
                    //console.log('No prev Route, goto /');
                    this.$router.push('/');
                }
                response.data = '';
            })
            .catch(err => {
                console.log("POST Login failed: ", err);
                // FIXME: Visual ERROR

            });
        },
    },
    beforeMount(){
        this.loadRecaptchaKeyFromServer();
    },
    mounted(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}
</script>
